import { ButtonVariant } from "./types";

export const baseClass = "text-base rounded-md items-center inline-flex gap-2 justify-center disabled:!opacity-70 whitespace-nowrap";

export const iconBaseClass = "self-center";

export const getVariantClass = (variant: ButtonVariant) => {
  switch (variant) {
    case "secondary":
      return "bg-white text-neutral-dark-gray border enabled:border-neutral-mid-gray hover:bg-neutral-gray disabled:!bg-neutral-gray disabled:!text-neutral-silver-gray";
    case "tertiary": // TODO: remove this variant and use secondary instead
      return "bg-white text-neutral-dark-gray border enabled:border-neutral-mid-gray hover:bg-neutral-gray disabled:!bg-neutral-gray disabled:!text-neutral-silver-gray";
    case "tertiary-light":
      return "bg-transparent hover:bg-primary-light hover:text-primary-dark disabled:!text-neutral-silver-gray";
    case "info":
      return "bg-info text-white hover:bg-info/70 disabled:!bg-info-light";
    case "primary":
      return "bg-primary text-white border border-primary hover:bg-primary-dark disabled:!border-0 disabled:!bg-neutral-gray disabled:!text-neutral-silver-gray";
    default:
      return "bg-transparent hover:bg-transparent hover:opacity-70 disabled:!bg-neutral-gray disabled:!text-neutral-dark-gray";
  }
};
